import { FC, ReactNode } from "react";
import { Card } from "../../primitives/Card";
import { ClickableIcon } from "../../primitives/ClickableIcon";

export type DetailCardProps = {
	title: ReactNode;
	onEdit?: () => void;
	onDelete?: () => void;
	children: ReactNode;
};

export const DetailCard: FC<DetailCardProps> = ({ title, onEdit, onDelete, children }) => (
	<Card elevation="raised" className="w-[300px] px-0">
		<Card.Header className="border-b-0 pb-0 px-4">
			<Card.Title className="flex items-center space-x-[6px] min-w-0">{title}</Card.Title>
			<Card.Actions>
				{onEdit && (
					<ClickableIcon type="pencil-square" color="secondary" size="mini" onClick={onEdit} />
				)}
				{onDelete && (
					<ClickableIcon
						data-testid="delete-contact"
						type="trash"
						color="danger"
						size="mini"
						onClick={onDelete}
					/>
				)}
			</Card.Actions>
		</Card.Header>
		<Card.Body className="pt-0">{children}</Card.Body>
	</Card>
);
